export default "__VITE_ASSET__8ecfda12__"